"use client";
import React from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import PopOver from "../../atoms/popOver";
import AddonLayout from "./addonLayout";
import { addOnModalVisibility } from "../../../store/slices/common/addOn";
import Loader from "../../atoms/loader";
import {
  resetGetDeliveryDateAndGeoPriceAction,
  resetMultiProductDateRange,
  setDeliveryDetailsAction,
} from "../../../store/slices/common/shippingDateAndSlotSelection";
import {
  requestToCartNotification,
  setIsCartVisible,
  setRedirectToAddonFromCart,
} from "../../../store/slices/cartSlice";
import { ADD_ON } from "../../../constants/common/common";
import { setSelectedCartProduct } from "../../../store/slices/cartSlice";
import { cleverTapCommonEvents } from "../../../analytics/clevertapConstants";
import useAnalytics from "../../../analytics/useAnalytics";

/**
 * Component that handles the selection of add-ons,
 * allowing users to choose from available options and manage their selections.
 *
 * @returns {JSX.Element} The rendered add-on selection component.
 */
const AddonSelection = ({ isMobile, commonCleverTapData }) => {
  const dispatch = useDispatch();
  const { trackEvent } = useAnalytics();
  const { isModalOpen, loading } = useSelector((state) => state.addOn);
  const redirectToAddonFromCart = useSelector((state) => state.cart?.redirectToAddonFromCart);
  const addonViewAndClose = {
    ...commonCleverTapData,
    is_date_today: null,
    is_date_tomorrow: null,
    is_variant_selected: null,
  };

  /**
   * Handles the closure of the add-on modal by updating the visibility state
   * and resetting the delivery details.
   */
  const onClose = () => {
    dispatch(addOnModalVisibility(false));
    dispatch(setDeliveryDetailsAction({}));
    dispatch(resetGetDeliveryDateAndGeoPriceAction());
    dispatch(resetMultiProductDateRange());
    dispatch(setSelectedCartProduct({}));
    if (redirectToAddonFromCart) {
      dispatch(setIsCartVisible(true));
      dispatch(setRedirectToAddonFromCart(false));
    } else {
      dispatch(requestToCartNotification({ isMobile, screen: ADD_ON }));
    }
    trackEvent(cleverTapCommonEvents.addonClosed, addonViewAndClose, ["clevertap"]);
  };

  return (
    <>
      {loading && <Loader />}
      <PopOver
        isVisible={isModalOpen}
        classes={
          "md:top-[10%] md:bottom-auto  md:overflow-y-hidden md:left-[9%] w-[100%] md:w-[80%] rounded-none md:rounded-2xl"
        }
        isBackdrop={true}
      >
        <AddonLayout onClose={onClose} commonCleverTapData={commonCleverTapData} />
      </PopOver>
    </>
  );
};

export default AddonSelection;

AddonSelection.propTypes = {
  isMobile: PropTypes.bool,
  commonCleverTapData: PropTypes.object,
};
